import React from 'react'
import AcquireWebComponent from '../../framework/MaterialUI'
import { map, sortBy, reverse } from 'lodash'
import ArrowDown from 'material-ui/svg-icons/navigation/arrow-drop-down';
import ArrowUp from 'material-ui/svg-icons/navigation/arrow-drop-up';
import moment from 'moment'

const styles = {
	tableHeaderStyle: {
		border: 'none',
		background: '#E4E4E4'
	},
	arrowStyle: {
		position: 'absolute',
		top: '0.4em'
	},
	tableHeaderColumn: {
		height: '30px',
		color: 'black',
		cursor: 'pointer',
		fontWeight: 'bolder',
		paddingLeft: '10px',
		position:'relative',
		whiteSpace:'nowrap',
		textOverflow:'ellipsis'
	},
	tableTd: {
		paddingLeft: '10px',
		height: '30px',
		borderBottom: '1px solid black',
		whiteSpace:'nowrap',
		overflow:'hidden',
		textOverflow:'ellipsis'
	},
	tableHeaderSortedColumn: {
		height: '30px',
		color: 'black',
		cursor: 'pointer',
		fontWeight: 'bolder',
		position:'relative',
		whiteSpace:'nowrap',
		textOverflow:'ellipsis',
		paddingLeft: '10px',
		backgroundColor: '#CECECE',
		backgroundClip: 'padding-box'
	},
	tableRowColumn: {
		position: 'relative'
	},
	settingStyle: {
		position: 'absolute',
		right: '6em',
		top: '0.9em',
		cursor: 'pointer'
	}
}

class WebTagsTable extends AcquireWebComponent {
	componentWillMount(){
		this.state={
			sortOrder: 'asc',
			sortColumn: 'name'
		}
	}
	handleHeaderClick(column){
		const sortOrder = this.state.sortColumn !== column ? 'asc' : 
			this.state.sortOrder === 'asc' ? "desc" : 'asc'
		this.setState({
			sortOrder: sortOrder,
			sortColumn: column
		})
	}
	sortIcon(column){
		const style={
			display:'inline-block',
			position: 'absolute',
			top:'3px',
			right:'0'
		}
		if (column === this.state.sortColumn){
			const icon = this.state.sortOrder === 'asc' ? <ArrowUp  onClick={() => this.handleHeaderClick(column)} style={{...style}} /> : 
				<ArrowDown style={{...style}} onClick={() => this.handleHeaderClick(column)} />
			return icon
		}
	}

	render(){
		const sortCol = this.state.sortColumn
		const tags = sortBy(this.props.client_tags, function(tag){
			switch(sortCol) {
				case 'domain':
					return tag.domain
				case 'id':
					return tag.uuid
				case 'created_date':
					return tag.createdDatetime
				default:
					return tag.siteName
			}
		})
		const {redirectUrl, client_info} = this.props
		return(
			<table style={{ width: '100%' }}>
			<thead style={styles.tableHeaderStyle}>
				<tr style={{ height: '30px', borderTop: '1px solid black', borderBottom: '1px solid black' }}>
					<th onClick={() => this.handleHeaderClick('name')} style={{ ...this.state.sortColumn === 'name' ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn, width: '23%' }}>
						Website Name
						{
							this.sortIcon('name')
						}
					</th>
					<th onClick={() => this.handleHeaderClick('domain')} style={{ ...this.state.sortColumn === 'domain' ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn, width: '25%' }}>
						Website Domain
						{
							this.sortIcon('domain')
						}
					</th>
					<th onClick={() => this.handleHeaderClick('id')} style={{ ...this.state.sortColumn === 'id' ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn, width: '19%' }}>
						Insights Tag ID
						{
							this.sortIcon('id')
						}
					</th>
					<th style={{ ...this.state.sortColumn === 'type' ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn, cursor:'default', width: '18%' }}>
						Tag Deployment Type
						{
							this.sortIcon('type')
						}
					</th>
					<th onClick={() => this.handleHeaderClick('created_date')} style={{ ...this.state.sortColumn === 'created_date' ? styles.tableHeaderSortedColumn : styles.tableHeaderColumn, width: '15%' }}>
						Tag Creation Date
						{
							this.sortIcon('created_date')
						}
					</th>
				</tr>
			</thead>
			<tbody>
				{
					map(this.state.sortOrder === 'desc' ? reverse(tags) : tags, (tag) => {
						if (tag.deploymentType === "Web")
							return (
								<tr key={tag.uuid}>
									<td style={styles.tableTd}>
										<a onClick={(e) => { e.preventDefault(); this.props.getTagDetail(client_info.id, tag.id, redirectUrl) }}>{tag.siteName}</a>
									</td>
									<td style={styles.tableTd}>
										{tag.domain}
									</td>
									<td style={styles.tableTd}>
										<div className='ellipse-cell' data-text={tag.uuid}>
											{tag.uuid}
										</div>
									</td>
									<td style={styles.tableTd}>
										{'Web Property'}
									</td>
									<td style={styles.tableTd}>
										{moment(tag.createdDatetime, 'x').format('MM/D/YY')}
									</td>
								</tr>
							)
					})
				}
			</tbody>
		</table>
		)
	}
}

export default WebTagsTable


// WEBPACK FOOTER //
// ./src/components/Insights/tags/WebTagsTable.jsx